import { Location } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CreateTicketComponent } from 'src/app/tickets/containers';
import { OrderContactsBoxComponent } from '../../../components/order-contacts-box/order-contacts-box.component';
import { OrderDatesBoxComponent } from '../../../components/order-dates-box/order-dates-box.component';
import { OrderDetailsBoxComponent } from '../../../components/order-details-box/order-details-box.component';

import * as Orders from '../../../domain';
import OrderContactInfo from '../../../components/order-contacts-box/order-contact-info.interface';
import OrderInfoDetail from '../../../domain/order-info.interface';

@Component({
  selector: 'app-view-order',
  templateUrl: './view-order.component.html',
  standalone: true,
  imports: [
    MatProgressSpinnerModule,
    MatIconModule,
    OrderDetailsBoxComponent,
    OrderDatesBoxComponent,
    OrderContactsBoxComponent,
  ],
})
export class ViewOrderComponent implements OnInit {
  @Input() order: Orders.Order = null;

  @Input() otherSites: Orders.Order[] = [];

  @Output() selectOrder: EventEmitter<Orders.Order> = new EventEmitter();

  @Output() back: EventEmitter<any> = new EventEmitter();

  loading: boolean = false;

  datesInCenter: boolean = false;

  generalInfo: OrderInfoDetail[];

  basicServiceInfo: OrderInfoDetail[];

  keyDates: OrderInfoDetail[];

  circuitOrdersInfo: OrderInfoDetail[];

  contactsInfo: OrderContactInfo[];

  private location = inject(Location);

  private dialog = inject(MatDialog);

  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.updateUrl();
    this.getAllInfo();
    if (
      this.order.type === Orders.OrderType.VOICE ||
      this.order.type === Orders.OrderType.SDWAN
    ) {
      this.datesInCenter = true;
      this.cdr.markForCheck();
    }
  }

  private updateUrl(): void {
    this.location.replaceState(`/orders-table/${this.order.id}/view`);
  }

  private getAllInfo(): void {
    if (!this.order) return;
    this.generalInfo = this.order.getGeneralInformation();
    this.basicServiceInfo = this.order.getBasicServiceInfo();
    this.keyDates = this.order.getDates();
    this.circuitOrdersInfo = this.order.getCircuitOrderInfo();
    this.contactsInfo = this.order.getContactsInfo();
    this.cdr.markForCheck();
  }

  goBack(): void {
    this.location.replaceState('/orders-table');
    this.back.emit();
  }

  openOtherOrder(order: Orders.Order): void {
    this.selectOrder.emit(order);
  }

  async onCreateTicket(): Promise<void> {
    const dialogConfig = {
      autoFocus: true,
      minHeight: '200px',
      maxHeight: 'calc(100vh - 20px)',
      width: '560px',
      maxWidth: 'calc(100vw - 20px)',
      data: {
        originPage: 'Service',
      },
      disableClose: true,
    };
    this.dialog.open(CreateTicketComponent, dialogConfig);
  }
}
